<template>
  <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" id="photosModal">
    <div class="modal-dialog" style="max-width: 1200px;">
      <div class="modal-content" id="photoModal">
        <div class="modal-body pb-0" id="simple_photo_checkbox">
          <div class="row">
            <div class="col-md-3">
              <SideNav/>
            </div>
            <div class="col-sm-9 pl-0">
              <span class="float-right" @click="closeModal()">
                <i class="fa fa-times" style="font-size:22px;"></i>
              </span>
              <p class="w-100 mb-2 text-dark" style="font-size: 1.45rem">
                {{ $t('add_photos') }}
              </p>
              <div class="row screen-height pr-3" id="simple_photo">
                <div class="col-xl-2 col-lg-2 col-md-3 pr-0" v-for="photo in images" :key="photo.id">
                  <div class="simple-photo" >
                    <input type="radio" class="d-none" name="cover-photo" v-model="coverImage" :id="'cb'+photo.id"  :value="photo.id"/>
                    <label :for="'cb'+photo.id">
                      <img class="img-fluid rounded" :src="photo.src" alt="img1"> </label>
                    <div class="simple-photo-option">
                      <ul>
                        <li>Nr.{{photo.runid}}</li>
                        <li>|</li>
                        <li>{{photo.photodate}}  </li>
                        <li>|</li>
                        <li>{{photo.photodate.substr(11,5)}}Uhr</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-2 pb-2">
              <sliding-pagination
                :current="$store.state.photo.page"
                :total="$store.state.photo.TPage"
                :perPage ="50"
                @page-change="pageChangeHandler"
                :classMap='{
                   "componentClass": "pagination-bottom border-top pt-2",
                   "list": "pagination justify-content-center pagination-sm",
                   "element": "page-item ",
                   "elementDisabled": "disabled",
                   "elementActive": "active",
                   "page": "page-link"
                 }' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SideNav from '../../../photo/components/SideNav'
import SlidingPagination from 'vue-sliding-pagination'
export default {
  components: {SideNav, SlidingPagination},
  data () {
    return {
    }
  },
  computed: {
    images () {
      return this.$store.state.photo.photos
    },
    coverImage: {
      get () {
        return this.$store.state.photoDocumentation.coverPhoto
      },
      set (photo_id) {
        this.$store.dispatch('setCoverImage', photo_id)
      }
    }
  },
  methods: {
    pageChangeHandler (selectedPage) {
      this.$store.state.photo.page = selectedPage
      this.$root.$emit('pageChangeHandler', selectedPage)
    },
    closeModal () {
      // TODO: close Modal give the id via Javascript
      if ($('input[name=cover-photo]:checked').length > 0) {
        let savedID = localStorage.setItem('savedID', $('input[name=cover-photo]:checked').val())
        let tempID = localStorage.getItem('savedID')
        $('.Picture_Window_Canvas').attr('id', tempID)
      }
      $('#photosModal').modal('toggle')
      $('.pointer-box').css('visibility', 'visible')
    }
  }
}
</script>
<style scoped>
#mySidenav{
  width: 90% !important;
  margin-left: 5px !important;
}
.accordion-style .custom-control-label::after{
  border: 1px solid !important;
  border-radius: 50% !important;
}
#simple_photo_checkbox label::before{
  top: 3px !important;
}
#collapse-left-heading-5 h5{
  padding-top: 10px;
  padding-bottom: 10px;
}
.sidenav {
  height: calc(100vh - 120px);
}
</style>



// WEBPACK FOOTER //
// src/components/photoDocumentation/components/PhotoDetails/CoverPhotoModal.vue